export default "<bx-image-gallery [images]=\"images\" [showProduct]=\"showProduct\" (imageChange)=\"galleryImageChanged($event)\">\n</bx-image-gallery>\n"